<template>
  <div class="col-sm-12 nopads pt-2">
      <power-station-search
          :user="user"
          @search="fetchStations"
      />
      <div class="col-sm-12">
        <div
          class="button-container trip-buttons col-sm-12"
        >
          <button
            class="btn  btn-outline-primary form-button"
            :disabled="loading"
            @click="importFromFile"
          >
            {{ $t('common.import_from_file') }}
          </button>
          <button
            v-if="results.length > 0"
            :disabled="loading || results.length < 1"
            class="btn  btn-outline-success form-button"
            @click="exportExcel"
          >
            {{ $t('trip.download_excel') }}
          </button>
        </div>
        <power-station-list
          :power-stations="results"
          @row-clicked="editCenter"
        />
      </div>

    <power-station-wizard
      v-if="powerStation != null"
      :power-station="powerStation"
      @close="powerStation=null"
      @close-and-update="closeAndUpdate"
    />

    <power-stations-importer
      v-if="showFileImporter"
      @close="showFileImporter = false"
    />

    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>


<script>
import {restApi} from '../mixins/RestApiMixin'
import {downloadHelper} from "../mixins/DownloadMixin";
import PowerStationSearch from "@/components/streetlights/PowerStationSearch";
import PowerStationList from "@/components/streetlights/PowerStationList";
import PowerStationWizard from "@/components/streetlights/PowerStationWizard";
import PowerStationsImporter from "@/components/streetlights/PowerStationImporter";
import {inject} from "vue";

export default {
    name: 'PowerStations',
    components: {PowerStationsImporter, PowerStationWizard, PowerStationList, PowerStationSearch},
    mixins: [restApi, downloadHelper],
    props: {
        user: {
            type: Object,
            default: null
        },
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data: function () {
        return {
            results: [],
            powerStation: null,
            loading: false,
            lastSearchedParams: null,
            showFileImporter: false
        }
    },

    methods: {
        fetchStations: function (params) {
            this.loading = true
            this.lastSearchedParams = params
            this.results = []
            this.restFetchParams(this.powerStationUrl, this.lastSearchedParams, this.handleSearch, () => {
                this.loading = false
            })
        },
        handleSearch: function (response) {
            this.results = response.data
            this.loading = false
        },
        editCenter: function (center) {
            this.powerStation = this.results.find(item => item.id === center.id)
        },
        closeAndUpdate: function () {
            this.powerStation = null
            this.fetchStations(this.lastSearchedParams)
        },
        exportExcel: function () {
            this.loading = true
            this.restGetDownloadFile(this.powerStationXlsxUrl, this.getCommonReportParams(this.lastSearchedParams), this.excelDownloadSuccess, this.fileDownloadFail)
        },
        excelDownloadSuccess: function (response) {
            this.loading = false
            this.downloadFile(response, this.$t('power_stations.report_file_name'))
        },
        fileDownloadFail: function () {
            this.loading = false
            this.showAlert(this.$t('common.report_generation_failed'))
        },
        importFromFile() {
            this.showFileImporter = true
        },
        hideFileImporter() {
            this.showFileImporter = false
            this.fetchStations()
        }
    }
}
</script>
